import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback } from 'react';
import { NodeSelection } from '@atlaskit/editor-prosemirror/state';
import { ASSETS_LIST_OF_LINKS_DATASOURCE_ID, AssetsConfigModal, JIRA_LIST_OF_LINKS_DATASOURCE_ID, JiraIssuesConfigModal } from '@atlaskit/link-datasource';
import { hideDatasourceModal } from '../../pm-plugins/actions';
import { insertDatasource, updateExistingDatasource } from '../../pm-plugins/doc';
export var DatasourceModal = function DatasourceModal(_ref) {
  var view = _ref.view,
    modalType = _ref.modalType;
  var dispatch = view.dispatch,
    state = view.state;
  var selection = state.selection;
  var existingNode = selection instanceof NodeSelection ? selection.node : undefined;
  var onClose = useCallback(function () {
    dispatch(hideDatasourceModal(state.tr));
  }, [dispatch, state.tr]);
  var onInsert = useCallback(function (newAdf) {
    if (existingNode) {
      updateExistingDatasource(state, existingNode, newAdf, view);
    } else {
      insertDatasource(state, newAdf, view);
    }
  }, [existingNode, state, view]);
  if (modalType === 'jira') {
    var _existingNode$attrs, _tableView$properties;
    var _ref2 = (existingNode === null || existingNode === void 0 ? void 0 : (_existingNode$attrs = existingNode.attrs) === null || _existingNode$attrs === void 0 ? void 0 : _existingNode$attrs.datasource) || {},
      _ref2$id = _ref2.id,
      datasourceId = _ref2$id === void 0 ? JIRA_LIST_OF_LINKS_DATASOURCE_ID : _ref2$id,
      parameters = _ref2.parameters,
      _ref2$views = _ref2.views,
      views = _ref2$views === void 0 ? [] : _ref2$views;
    var _ref3 = views,
      _ref4 = _slicedToArray(_ref3, 1),
      tableView = _ref4[0];
    var visibleColumnKeys = tableView === null || tableView === void 0 ? void 0 : (_tableView$properties = tableView.properties) === null || _tableView$properties === void 0 ? void 0 : _tableView$properties.columns.map(function (column) {
      return column.key;
    });
    return /*#__PURE__*/React.createElement("div", {
      "data-testid": "jira-config-modal"
    }, /*#__PURE__*/React.createElement(JiraIssuesConfigModal, {
      datasourceId: datasourceId,
      visibleColumnKeys: visibleColumnKeys,
      parameters: parameters,
      onCancel: onClose,
      onInsert: onInsert
    }));
  }
  if (modalType === 'assets') {
    var _existingNode$attrs2, _tableView$properties2;
    var _ref5 = (existingNode === null || existingNode === void 0 ? void 0 : (_existingNode$attrs2 = existingNode.attrs) === null || _existingNode$attrs2 === void 0 ? void 0 : _existingNode$attrs2.datasource) || {},
      _ref5$id = _ref5.id,
      _datasourceId = _ref5$id === void 0 ? ASSETS_LIST_OF_LINKS_DATASOURCE_ID : _ref5$id,
      _parameters = _ref5.parameters,
      _ref5$views = _ref5.views,
      _views = _ref5$views === void 0 ? [] : _ref5$views;
    var _ref6 = _views,
      _ref7 = _slicedToArray(_ref6, 1),
      _tableView = _ref7[0];
    var _visibleColumnKeys = _tableView === null || _tableView === void 0 ? void 0 : (_tableView$properties2 = _tableView.properties) === null || _tableView$properties2 === void 0 ? void 0 : _tableView$properties2.columns.map(function (column) {
      return column.key;
    });
    return /*#__PURE__*/React.createElement("div", {
      "data-testid": "assets-config-modal"
    }, /*#__PURE__*/React.createElement(AssetsConfigModal, {
      datasourceId: _datasourceId,
      visibleColumnKeys: _visibleColumnKeys,
      parameters: _parameters,
      onCancel: onClose,
      onInsert: onInsert
    }));
  }
  return null; // null for now until we have modal component that handles other datasources
};